<template>
  <div class="main">
    <!-- 开票成功 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('changePage', 'blueInvoice_home')"><Back /></el-icon>
        <el-breadcrumb separator-icon="arrowRight">
          <el-breadcrumb-item>蓝字发票开具</el-breadcrumb-item>
          <el-breadcrumb-item>立即开票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="operate-main">
      <div class="common-box">
        <div style="text-align: center">
          <img src="https://static.rhkj.com/renhe_fe/other/blueInvoice/dui.png" alt="#" style="width: 45px" />
          <p style="text-align: center; font-size: 16; color: #333; font-weight: 600; line-height: 30px">开票成功</p>
          <p style="font-size: 12px; color: #999">对方可在税务数字账户中查收</p>
        </div>
        <div style="text-align: center; cursor: pointer" @click="warn()">
          <img src="https://static.rhkj.com/renhe_fe/other/blueInvoice/blue_icons.png" alt="#" style="height: 74px" />
        </div>
        <div style="padding: 20px; background-color: #f9fafe">
          <p style="line-height: 24px; font-weight: 600; font-size: 14px">发票简要信息</p>
          <div style="margin-top: 20px; line-height: 24px; font-size: 14px; display: flex; gap: 20px">
            <p>
              <span style="color: #666"> 购方税号:</span><span style="color: #333">{{ info.buyer?.taxRegistrationNo }}</span>
            </p>
            <p>
              <span style="color: #666"> 购方名称:</span><span style="color: #333">{{ info.buyer?.name }}</span>
            </p>
          </div>
          <div style="margin-top: 20px; line-height: 24px; font-size: 14px; display: flex; justify-content: space-between; gap: 20px">
            <p>
              <span style="color: #666"> 开票时间:</span><span style="color: #333">{{ info.makeDate }}</span>
            </p>
            <p>
              <span style="color: #666"> 价税合计(元):</span><span style="color: #333">{{ info.totalAddedTaxAmount }}</span>
            </p>
            <p>
              <span style="color: #666"> 全电发票号码:</span><span style="color: #333">{{ info.number }}</span>
            </p>
          </div>

          <p style="margin-top: 20px; font-weight: 600; font-size: 14px">授信额度信息</p>
          <p style="margin-top: 20px; font-size: 14px">
            <span style="color: #666"> 当前可开票授信额度:</span><span style="color: #333">{{ showRemainAmount }}</span>
          </p>
        </div>
        <div style="width: 100%; margin-top: 20px; display: inline-flex; justify-content: center">
          <el-button type="default" @click="emits('goInvoice')">退出开票</el-button>
          <el-button type="default" @click="goPreview()">查看开票</el-button>
          <el-button type="default" @click="warn()">复制发票</el-button>
          <el-button type="primary" @click="emits('changePage', 'blueInvoice_invoicing')">继续开票</el-button>
        </div>
      </div>
    </div>

    <invoce-dialog
        v-model="previewVis"
        :row="info"
    />
  </div>
</template>

<script setup name="BlueInvoice/openEnd">
import useInvoiceStore from '@/store/modules/invoice';
import InvoceDialog from "@/views/digitalInvoice/cmp/invoceDialog.vue";
import {useAllInvoice} from "@/views/digitalInvoice/invoiceQueryStatist/allInvoiceSummary.js";
import Big from "big.js";

const useInvoice = useInvoiceStore();

const emits = defineEmits(['changePage', 'goInvoice']);

const info = ref({});

onMounted(() => {
  getInvoiceDetail();
});

const {usageStatist} = useAllInvoice()
const showRemainAmount = computed(() => {
  if (usageStatist.value?.remainAmount == null || info.value.addedTax == null) {
    return ''
  }
  const current = info.value.addedTax ?
      new Big(info.value.totalAmount).plus(info.value.totalTaxAmount * -1) :
      new Big(info.value.totalAmount)
  return new Big(usageStatist.value.Number_remainAmount).minus(current).toFixed(2)
})

async function getInvoiceDetail() {
  if (sessionStorage.getItem('fapiao_id')) {
    const id = sessionStorage.getItem('fapiao_id');
    useInvoice.blueInvoiceList.forEach((item) => {
      if (item.id == id) {
        info.value = Object.assign({}, item);
      }
    });
    sessionStorage.removeItem('fapiao_id');
  }
}

//警告功能
function warn(content) {
  let msg = content ? content : '本系统为教学系统，暂不支持此功能';
  ElMessageBox.confirm(msg, '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}

const previewVis = ref(false)

function goPreview() {
  previewVis.value = true
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: #f6f7fb;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      :deep(.el-breadcrumb) {
        .el-breadcrumb__item {
          font-size: 0.16rem;
          .el-breadcrumb__inner {
            font-weight: 400;
            line-height: 0.6rem;
            color: #333;
          }
          &:last-child {
            .el-breadcrumb__inner {
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 600px;
    padding: 20px;
    background: #fff content-box;

    .common-box {
      box-sizing: border-box;
      width: 800px;
      height: 100%;
      padding: 20px;
      margin: 0 auto;
    }
  }
}
</style>
